
import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { FaFileExcel, FaFilePdf } from "react-icons/fa";
import {ResponsiveContainer, LineChart, Line, XAxis,YAxis,CartesianGrid,Tooltip,} from "recharts";

const ExpensesReport = () => {
  const [purchaseData, setPurchaseData] = useState([]);
const [fromDate, setFromDate] = useState("");
const [toDate, setToDate] = useState("");
  const client_id = localStorage.getItem("client_id");

useEffect(() => {
  if (!client_id) return;

  if (fromDate && toDate && fromDate > toDate) {
    return;
  }

  fetchPurchaseHistory();
}, [fromDate, toDate, client_id]);
 const fetchPurchaseHistory = async () => {
  try {
    const res = await axios.get(
      `https://api.dectwinbilling.com/fetch-expense-bill-report/${client_id}`,
      {
        params: {
          fromDate: fromDate || undefined,
          toDate: toDate || undefined,
        },
      }
    );

    setPurchaseData(res.data || []);

  } catch (err) {
    console.log("Expense Report Error:", err);
  }
};

 


  const chartData = useMemo(() => {
  const grouped = {};

  purchaseData.forEach((item) => {
    if (!item.date) return;

    const datePart = item.date.split(" ")[0];
    const [year, month, day] = datePart.split("-");

    const date = `${day}/${month}/${year}`;

    if (!grouped[date]) {
      grouped[date] = {
        date,
        amount: 0,
        count: 0,
      };
    }

    grouped[date].count += 1;

    grouped[date].amount += Number(item.paid || 0);
  });

  return Object.values(grouped);
}, [purchaseData]);


const totalPurchase = chartData.reduce(
  (sum, item) => sum + item.amount,
  0
);



  const exportToExcel = async () => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Expenses Report");

  worksheet.addRow(["EXPENSES REPORT"]);
  worksheet.mergeCells("A1:C1");

  const title = worksheet.getCell("A1");

  title.font = {
    bold: true,
    size: 18,
    color: { argb: "FFFFFF" },
  };

  title.fill = {
    type: "pattern",
    pattern: "solid",
    fgColor: { argb: "1F4E78" },
  };

  title.alignment = {
    horizontal: "center",
  };

  worksheet.addRow([]);
  worksheet.addRow(["From Date", fromDate || "All"]);
  worksheet.addRow(["To Date", toDate || "All"]);
  worksheet.addRow(["Generated On", new Date().toLocaleString()]);
  worksheet.addRow([]);

  worksheet.addRow([
    "Date",
    "Expenses",
    "Total Amount",
  ]);

  const header = worksheet.getRow(7);

  header.font = {
    bold: true,
    color: { argb: "FFFFFF" },
  };

  header.fill = {
    type: "pattern",
    pattern: "solid",
    fgColor: { argb: "4472C4" },
  };

  chartData.forEach((item) => {
    worksheet.addRow([
      item.date,
      item.count,
      item.amount.toFixed(2),
    ]);
  });

  worksheet.addRow([]);

  worksheet.addRow([
    "Total Expenses",
    purchaseData.length,
    totalPurchase.toFixed(2),
  ]);

  worksheet.columns = [
    { width: 20 },
    { width: 18 },
    { width: 22 },
  ];

  worksheet.eachRow((row) => {
    row.eachCell((cell) => {
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
    });
  });

  const buffer = await workbook.xlsx.writeBuffer();

  saveAs(
    new Blob([buffer]),
    "Expenses_Report.xlsx"
  );
};

const exportToPDF = () => {
  const doc = new jsPDF();

  doc.setFontSize(18);
  doc.text("Expenses Report", 14, 18);

  doc.setFontSize(11);

  doc.text(
    `From Date : ${fromDate || "All"}`,
    14,
    28
  );

  doc.text(
    `To Date : ${toDate || "All"}`,
    14,
    35
  );

  doc.text(
    `Generated On : ${new Date().toLocaleString()}`,
    14,
    42
  );

  autoTable(doc, {
    startY: 50,

    head: [[
      "Date",
      "Expenses",
      "Total Amount",
    ]],

    body: chartData.map((item) => [
      item.date,
      item.count,
      `Rs. ${item.amount.toFixed(2)}`,
    ]),

    theme: "grid",

    headStyles: {
      fillColor: [68, 114, 196],
    },
  });

  const finalY = doc.lastAutoTable.finalY + 10;

  doc.text(
    `Total Expenses : ${purchaseData.length}`,
    14,
    finalY
  );

  doc.text(
    `Total Amount : Rs. ${totalPurchase.toFixed(2)}`,
    14,
    finalY + 8
  );

  doc.save("Expenses_Report.pdf");
};

  return (
    <div className="container-fluid mt-3">
      <div className="row mb-3">

  <div className="col-6 col-md-6">
    <label className="form-label fw-bold">From Date</label>
    <input
      type="date"
      className="form-control w-100 w-md-50"
      style={{ maxWidth: "220px" }}
      value={fromDate}
      onChange={(e) => setFromDate(e.target.value)}
    />
  </div>

  <div className="col-6 col-md-6 d-flex flex-column align-items-md-end">
    <label className="form-label fw-bold">To Date</label>
    <input
      type="date"
      className="form-control w-100"
      style={{ maxWidth: "220px" }}
      value={toDate}
      onChange={(e) => setToDate(e.target.value)}
    />
  </div>

</div>
<div className="row g-3">





  <div className="col-12 col-md-4">

    <div className="card shadow h-100">


    <div
  className="table-responsive shadow-sm"
  style={{
    maxHeight: "500px",
    overflowY: "auto",
    borderRadius: "15px",
    border: "1px solid #e9ecef",
    background: "#fff",
  }}
>
        <table className="table table-bordered table-hover text-center mb-0">

       
          <thead
  className="sticky-top"
  style={{
    background: "linear-gradient(90deg,#4f46e5,#7c3aed)",
    color: "#fff",
  }}
>
  <tr>
    <th className="py-3"> Date</th>
    <th className="py-3"> Expenses</th>
    <th className="py-3"> Total</th>
  </tr>
</thead>
 


          <tbody>
  {chartData.length ? (
    chartData.map((item, index) => (
      <tr key={index}>
        <td className="fw-semibold">{item.date}</td>

        <td>
          <span className=" px-3 py-2">
            {item.count}
          </span>
        </td>

        {/* <td className="fw-bold text-success">
          ₹{item.paid}
        </td> */}
         ₹{item.amount.toFixed(2)}
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="3" className="py-5 text-muted">
        No Purchase Found
      </td>
    </tr>
  )}
</tbody>

        </table>
      </div>

    </div>

  </div>


<div className="col-12 col-lg-8">

  <div
    className="card border-0 shadow-lg"
    style={{ borderRadius: "18px" }}
  >
 
    <div className="card-body">
      <div className="row g-3 mb-4">

        <div className="col-md-6">
          <h1>Expenses Report</h1>
   
        </div>

      </div>

      
      <div
        className="p-3 rounded-4"
        style={{
          height: "430px",
          background: "#fff",
          border: "1px solid #ececec",
        }}
      >
        <ResponsiveContainer width="100%" height="100%">

          <LineChart
            data={chartData}
            margin={{
              top: 20,
              right: 30,
              left: 10,
              bottom: 10,
            }}
          >

            <CartesianGrid
              strokeDasharray="4 4"
              stroke="#e5e7eb"
            />

            <XAxis
              dataKey="date"
              tick={{ fontSize: 12 }}
            />

            <YAxis
              tick={{ fontSize: 12 }}
            />

            <Tooltip
              contentStyle={{
                borderRadius: "10px",
                border: "none",
                boxShadow: "0 4px 15px rgba(0,0,0,.15)",
              }}
            />

            <Line
              type="monotone"
              dataKey="amount"
              stroke="#4F46E5"
              strokeWidth={4}
              dot={{
                r: 5,
                fill: "#4F46E5",
              }}
              activeDot={{
                r: 8,
              }}
            />

          </LineChart>

        </ResponsiveContainer>
      </div>

    </div>

  </div>

</div>


<div className="d-flex justify-content-end gap-3 mt-3 flex-wrap">


  <button
    className="btn d-flex align-items-center gap-2 px-4 py-2 shadow"
    onClick={exportToExcel}
    style={{
      background: "linear-gradient(135deg, #28a745, #198754)",
      color: "#fff",
      border: "none",
      borderRadius: "10px",
      fontWeight: "600",
      transition: "0.3s ease",
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.transform = "translateY(-2px)";
      e.currentTarget.style.boxShadow =
        "0 8px 20px rgba(25,135,84,0.35)";
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.transform = "translateY(0)";
      e.currentTarget.style.boxShadow = "";
    }}
  >
    <FaFileExcel size={20} />
    Excel
  </button>

  
  <button
    className="btn d-flex align-items-center gap-2 px-4 py-2 shadow"
    onClick={exportToPDF}
    style={{
      background: "linear-gradient(135deg, #dc3545, #b02a37)",
      color: "#fff",
      border: "none",
      borderRadius: "10px",
      fontWeight: "600",
      transition: "0.3s ease",
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.transform = "translateY(-2px)";
      e.currentTarget.style.boxShadow =
        "0 8px 20px rgba(220,53,69,0.35)";
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.transform = "translateY(0)";
      e.currentTarget.style.boxShadow = "";
    }}
  >
    <FaFilePdf size={20} />
    PDF
  </button>
  

</div>

</div>

    </div>
    
  );
};

export default ExpensesReport;
